// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__WZ3UK","balanceDisclaimer":"posDashboard_balanceDisclaimer__hrNB0"};